import { AsyncPageRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const TABS = createTabs([
    ['all', 'All Orders', AsyncPageRender(() => import('./AllOrders'))],
    ['archived-orders', 'Archives', AsyncPageRender(() => import('./ArchivedOrders'))],
]);
